import {
	TdcGetEvaluationResponse,
	TdcProductCompleteEvaluation,
} from 'src/app/models/apis/tdc/tdc-evaluation.model';
import {
	RejectionObservation,
	TdcCard,
	TdcApplicationEvaluation,
} from 'src/app/models/tdc/tdc-evaluation.model';

const DEFAULT_CARD_TYPE = 2;
export const getTdcApplicationEvaluationFrom = (
	tdcCompleteEvaluationResponse: TdcGetEvaluationResponse
): TdcApplicationEvaluation => {
	const { EvaluacionClasica, EvaluacionOro } = tdcCompleteEvaluationResponse;
	const hasAnyCardApprobed: boolean =
		EvaluacionClasica.solicitud_aprobada ||
		EvaluacionClasica.solicitud_aprobada;
	if (!hasAnyCardApprobed) {
		return {
			applicationId: 0,
			evaluation: {
				hasAnyCardApprobed,
				rejectionObservations: [
					mapRejectedObservationFrom(EvaluacionOro),
					mapRejectedObservationFrom(EvaluacionClasica),
				],
			},
		};
	}

	const applicationId = getApplicationId(tdcCompleteEvaluationResponse);

	return {
		applicationId,
		evaluation: {
			hasAnyCardApprobed,
			approvedCards: [
				mapTdcCardFrom(EvaluacionClasica),
				mapTdcCardFrom(EvaluacionOro),
			],
		},
	};
};

const getApplicationId = (
	tdcGetEvaluationResponse: TdcGetEvaluationResponse
): number => {
	const { EvaluacionClasica, EvaluacionOro } = tdcGetEvaluationResponse;
	if (EvaluacionClasica.solicitud_aprobada) {
		return EvaluacionClasica.id_solicitud;
	}

	if (EvaluacionOro.solicitud_aprobada) {
		return EvaluacionOro.id_solicitud;
	}
	return 0;
};

const mapTdcCardFrom = (
	tdcProductEvaluationResult: TdcProductCompleteEvaluation
): TdcCard => {
	return {
		typeId: tdcProductEvaluationResult.id_tipo_tarjeta,
		name: '',
		creditLine: tdcProductEvaluationResult.monto_linea_credito,
		isDefault: tdcProductEvaluationResult.id_tipo_tarjeta === DEFAULT_CARD_TYPE,
	};
};
const mapRejectedObservationFrom = (
	ResultadoEvaluacionOro: TdcProductCompleteEvaluation
): RejectionObservation => {
	return {
		card: {
			name: '',
			typeId: ResultadoEvaluacionOro.id_tipo_tarjeta,
		},
		observation: ResultadoEvaluacionOro.observaciones,
	};
};
